<template>
  <div class="structured-description relative">
    <BasePreloader v-if="loading" />

    <template v-else>
      <div class="container">
        <StructuredDescriptionTopSection
          :header-links="headerLinks"
          :section-block="pageData.block1"
          :section-custom-btn-action="goToSecondSection"
        />
        <StructuredDescriptionDiffListsBlocks
          :title="pageData.block2.title"
          :first-data-item="pageData.block2.sub1"
          :second-data-item="pageData.block2.sub2"
          @click:right-activate-btn="selectPlanRightClick"
        />
        <EmployersLTPageHowItWork
          :section="pageData.block3"
          :use-section-btn="false"
          class="_bg-white relative"
        />
        <EmployersPLPageOrder
          v-if="showForm"
          :use-only-fields="formUseOnlyFields"
          :labels="formLabels"
          :section="pageData.form"
          request-url="/api/helper/landing/employer-poland-v2/form"
          class="structured-description__how-it-works"
        />
      </div>
      <div class="structured-description__preferrals-wrap container">
        <StructuredDescriptionPreferrals :preferrals-data="pageData.block4" />
      </div>

      <EmployersLTPageAgents
        v-if="$get(pageData, 'reviews.items.data.length')"
        :section="pageData.reviews"
      >
        <template v-slot:btn>
          <a
            class="base-btn base-btn--blue reviews__btn"
            :href="pageData.reviews.button.url"
            @click.prevent="goToForm"
          >
            <span class="base-btn__text">{{ pageData.reviews.button.text }}</span>
          </a>
        </template>
      </EmployersLTPageAgents>

      <HomePageVideo :video="pageData.video"/>
      <AddressSection :title="pageData.addresses.title" :addresses="pageData.addresses.items" />
    </template>
  </div>
</template>

<script>
import {http} from '../axios';
import globalMetaMixin from "@/mixins/globalMetaMixin"
import StructuredDescriptionTopSection from '../components/structuredDescription/StructuredDescriptionTopSection';
import StructuredDescriptionDiffListsBlocks from '../components/structuredDescription/StructuredDescriptionDiffListsBlocks';
import EmployersLTPageHowItWork from '../components/employersLTPage/EmployersLTPageHowItWork'
import EmployersPLPageOrder from '../components/employersPLPage/EmployersPLPageOrder'
import StructuredDescriptionPreferrals from '../components/structuredDescription/StructuredDescriptionPreferrals';
import EmployersLTPageAgents from '../components/employersLTPage/EmployersLTPageAgents';
import HomePageVideo from '../components/homePage/HomePageVideo';
import AddressSection from '../components/AddressSection';

export default {
  name: 'EmployerPolandPage',
  components: {
    StructuredDescriptionTopSection,
    StructuredDescriptionDiffListsBlocks,
    EmployersLTPageHowItWork,
    EmployersPLPageOrder,
    StructuredDescriptionPreferrals,
    EmployersLTPageAgents,
    HomePageVideo,
    AddressSection,
  },
  mixins: [globalMetaMixin],
  data() {
    return {
      loading: false,
      pageData: null,
      showForm: false,
    };
  },
  computed: {
    headerLinks() {
      return [
        {
          icon: { name: 'ico-question', width: '1.5rem', height: '1.5rem' },
          ...this.pageData.header.link_1,
        },
        {
          icon: { name: 'ico-list-2', width: '1.7rem', height: '1.5rem' },
          ...this.pageData.header.link_2,
        },
        {
          icon: { name: 'ico-case', width: '1.7rem', height: '1.8rem' },
          ...this.pageData.header.link_3,
        },
      ];
    },
    formUseOnlyFields() {
      return ['company_name', 'contact_person', 'phone', 'email', 'i_agree'];
    },
    formLabels() {
      return {
        company_name: this.$tEmployerPoland('company_name'),
        contact_person: this.$tEmployerPoland('contact_person'),
        phone: this.$tEmployerPoland('contact_phone'),
        email: this.$tEmployerPoland('contact_email'),
      };
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const { data } = await http.get('/api/helper/landing/employer-poland-v2');
        this.pageData = data;

        this.setMetaTitleMixin(data.header.meta_title);
        this.setMetaDescriptionMixin(data.header.meta_description);
      } catch {
        this.$vModal.open('warning', { message: 'Something went wrong on load page' });
      } finally {
        this.loading = false;
      }
    },
    goToSecondSection() {
      this.$scrollTo('#employer-poland-page-tariff-lists', { offset: 0 });
    },
    goToForm() {
      this.$scrollTo('#employers-lt-order', { offset: 0 });
    },
    selectPlanRightClick() {
      this.showForm = true;
      setTimeout(() => this.goToForm());
    },
  },
};
</script>
